export const PERFORMANCE_METRICS = {
  resolutionRate: "76%",
  // Shown in the (i) info tooltip beside the resolution-rate chart/stat.
  resolutionRateMethodology:
    "Resolution Rate is calculated across conversations where Fin was involved.",
} as const;
